import moment from 'moment'
import { Entity } from './Entity'

export class Journey extends Entity {
	constructor (payload, api) {
		super (Object.assign({}, payload, {type:"journey"}), api);

		this.computed = {
			ad: () => {
				// Actual duration
				if (this.data.atd && this.data.ata) {
					const duration = moment(this.data.ata) - moment(this.data.atd);
					if (duration >= 0) {
						return duration;
					}
				}
				// return undefined
			},

			ed: () => {
				// Estimated duration
				if (this.data.etd && this.data.eta) {
					const duration = moment(this.data.eta) - moment(this.data.etd);
					if (duration >= 0) {
						return duration;
					}
				}
				// return undefined
			},

			sd: () => {
				// Scheduled duration
				if (this.data.std && this.data.sta) {
					const duration = moment(this.data.sta) - moment(this.data.std);
					if (duration >= 0) {
						return duration;
					}
				}
				// return undefined
			},

			distance: () => {
				if (this.data.odometerStart && this.data.odometerEnd) {
					const distance = this.data.odometerEnd - this.data.odometerStart;
					if (distance >= 0) {
						return distance;
					}
				}
				// TODO If trackGPX available, use it to calculate distance
			},

			delay: () => {
				const expectedArrival = this.data.eta || this.data.sta;
				if (this.data.ata && expectedArrival) {
					return moment(this.data.ata) - moment(expectedArrival);
				}
			}
		}

	}

	status (alarms, relativeTo) {
		// Journey alarms override defaults
		const _alarms = Object.assign(alarms, this.data.alarms);

		if (this.data.detresfa) {
			// detresfa
			return "detresfa";
		} else if (this.data.ata) {
			// completed
			return "completed";
		} else if (!this.data.atd) {
			if (this.departure()) {
				if (moment(this.departure()) < moment(relativeTo)) {
					return "pending";
				}
			}
			// inactive
			return "inactive";
		} else if (!(this.data.eta || this.data.sta)) {
			// incerfa (because there should be either ETA or STA
			return "incerfa";
		} else {
			let arrival = moment(this.data.eta || this.data.sta);
			let interval = (moment(relativeTo) - arrival)/1000;
			if (interval < 0) { // in the future
				// active
				return "active";
			} else if (interval < alarms.incerfa) {
				// incerfa
				return "incerfa";
			} else if (interval < alarms.alerfa) {
				// alerfa
				return "alerfa";
			} else {
				// detresfa
				return "detresfa";
			}
		}
	}

	progress (epoch) {
		if (this.data.atd) {
			if (this.data.ata) {
				return 1;
			} else if (this.data.eta || this.data.sta) {
				let departure = moment(this.data.atd);
				let arrival = moment(this.data.eta || this.data.sta);
				let duration = arrival - departure;
				return (moment(epoch) - departure)/duration;
			}
		}
		// return undefined
	}

	departure () {
		if (this.data.atd) {
			return this.data.atd;
		} else if (this.data.etd) {
			return this.data.etd;
		} else if (this.data.std) {
			return this.data.std;
		}
		// return undefined
	}

	arrival () {
		if (this.data.ata) {
			return this.data.ata;
		} else if (this.data.eta) {
			return this.data.eta;
		} else if (this.data.sta) {
			return this.data.sta;
		}
		// return undefined
	}

	origin () {
		return Entity.propName(this, "origin");
	}

	destination () {
		return Entity.propName(this, "destination");
	}

	geo () {
		let list = [];
		let origin = this.data.origin,
			destination = this.data.destination,
			waypoint = this.data.waypoint;

		if (origin && origin.data && origin.data.geo) {
			list.push({
				name: origin.data.name,
				latitude: origin.data.geo.latitude,
				longitude: origin.data.geo.longitude
			});

			if (waypoint) {
				if (!Array.isArray(waypoint)) {
					waypoint = [ waypoint ];
				}

				waypoint = waypoint.filter(w => w instanceof Object);

				for (let wpt of waypoint) {
					if (!wpt.geo) {
						return null;
					} else {
						list.push({
							name: wpt.name,
							latitude: wpt.geo.latitude,
							longitude: wpt.geo.longitude
						});
					}
				}
			}

			if (destination && destination.data && destination.data.geo) {
				list.push({
					name: destination.data.name,
					latitude: destination.data.geo.latitude,
					longitude: destination.data.geo.longitude
				});
				return list;
			}
		}
		return null;
	}

	/**
	 * Determine journey visibility
	 *
	 * @arg other Another entity
	 *
	 * Journeys follow the general visibility
	 * rules.
	 */
	isVisibleBy (other) {
		return super.isVisibleBy(other);
	}

	/**
	 * Determine if a journey is editable by another entity
	 *
	 * @arg other Another entity
	 *
	 * Journeys are editable by other entities with
	 * permissions "operator" and above, or by the entity
	 * that last modified it, if that entity has at least
	 * "driver" permisson.
	 *
	 */
	isEditableBy (other) {
		const acceptablePermissions = [ "operator", "manager", "admin", "master" ];
		const myOwner = this.updatedBy instanceof Object ? this.updatedBy.id : this.updatedBy;

		if (super.isEditableBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
				if (myOwner == other.id && other.permissions.includes("driver")) {
					return true;
				}
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/Journey.js